/*
 * http-commom.js
 *
 * 
 *
 * Author:
 *     Vinicius do Nascimento
 */

import axios from "axios";
import qs from 'qs';

const baseURL = 'https://admin.pontocomnegocios.com.br/api/';
const accessToken = '471443ea1aadea9345dc829c32a9db87';

export const HTTP_Api = axios.create({
  baseURL: baseURL,
});


export default {

  setClientId(client_id) {
    this.client_id = client_id;
  },
  setCategoryId(category_id) {
    this.category_id = category_id;
  },
  setSearchTerms(search_terms) {
    this.search_terms = search_terms;
  },
  getHomeData(page) {
    return axios.post(baseURL + 'home', qs.stringify({
        access_token: accessToken,
        per_page: page
    }));
  },
  getCategoryData(page) {
    return axios.post(baseURL + 'categoria', qs.stringify({
        access_token: accessToken,
        category_id: this.category_id,
        per_page: page
    }));
  },
  getSearchData(page) {
    return axios.post(baseURL + 'busca', qs.stringify({
        access_token: accessToken,
        search_terms: this.search_terms,
        per_page: page
    }));
  },
  getClientData(page) {
    return axios.post(baseURL + 'empresa', qs.stringify({
        access_token: accessToken,
        client_id: this.client_id,
        per_page: page
    }));
  }
};



// WEBPACK FOOTER //
// ./src/services/api.service.js